import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { createApplication, CREATE_APPLICATION} from "../../actions/student.action"

function* handleCreateApplication(action) {
  try {
    const { data : resData} = yield call(studentAPI.createApplication, action.payload);
    //extract the data here     
    yield put(createApplication.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(createApplication.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* createApplicationSaga() {
  yield takeLatest(CREATE_APPLICATION.REQUEST, handleCreateApplication);
}

export default createApplicationSaga;
